import { useQuery } from "@tanstack/react-query";
import { createFileRoute } from "@tanstack/react-router";
import { NamingSettings } from "@/components/settings/naming-settings";
import { companyQuery } from "@/lib/loaders";

export const Route = createFileRoute("/_workspace/settings/naming")({
  loader: ({ context }) => context.queryClient.ensureQueryData(companyQuery),
  component: SettingsNamingPage,
});

function SettingsNamingPage() {
  const { data: company } = useQuery(companyQuery);
  // Keyed by company so switching workspace re-reads the saved words.
  return <NamingSettings key={company?.id ?? "none"} />;
}
